/**
 *
 * Asynchronously loads the component for StripWithGuides
 *
 */

import { lazyLoad } from 'utils/loadable';

export const StripWithGuides = lazyLoad(
  () => import('./index'),
  module => module.StripWithGuides,
);
